export default __webpack_public_path__ + "static/media/delivery.59df4948.svg";